import request from './request'
import {
  GlAxios
} from 'glsx-vue-common'

export const commonApi = {
  /**图片上传接口*/
  upLoadImg(data = {}) {
    return request(data, 'dj.api.scrm.common.upload.image', 'post', ['file'])
  },
}
export const orderApi = {
  /**获取财务管理列表*/
  getBalanceList(data = {}) {
    return request(data, 'dj.api.get.equity.order.balance.list.get')
  },
  /** 获取订单列表*/
  getOrderList(data = {}) {
    return request(data, 'dj.api.get.equity.order.list.get')
  },
  /** 获取海威账户余额*/
  getHwAccount(data = {}) {
    return request(data, 'dj.api.get.equity.order.hw.account.balance.get')
  },
  /**获取订单详情 */
  getOrderDetail(data = {}) {
    return request(data, 'dj.api.get.equity.order.detail.get')
  },
  /** 开启售后状态修改*/
  openRefund(data = {}) {
    return request(data, 'dj.api.get.equity.order.refund.open')
  },
  /** 获取售后订单列表*/
  getRefundList(data = {}) {
    return request(data, 'dj.api.get.equity.order.refund.list.get')
  },
  /** 获取售后详情*/
  getRefundDetail(data = {}) {
    return request(data, 'dj.api.get.equity.order.refund.detail.get')
  },
  /** 获取e代驾订单列表*/
  getEDJOrderList(data = {}) {
    return request(data, 'dj.api.scrm.edj.orderList')
  },
  /** 分页获取订单列表*/
  getOilOrderList(data = {}) {
    return request(data, 'dj.api.scrm.oil.orderPage')
  },
  /**商品分页查询*/
  getGoodsList(data = {}) {
    return request(data, 'dj.api.scrm.goods.listWithPage')
  },
  /** 商品上架下架/支持批量*/
  goodsShelves(data = {}) {
    return request(data, 'dj.api.scrm.goods.shelves')
  },
  /**商品删除/支持批量*/
  deleteGoods(data = {}) {
    return request(data, 'dj.api.scrm.goods.delete')
  },
  /** 商品id获取商品信息*/
  getEquityGoodsById(data = {}) {
    return request(data, 'dj.api.scrm.goods.getEquityGoodsById')
  },
  /** 第三方商品分页查询*/
  getListWithPageOutGoods(data = {
    supplier: 'HW',
    pageSize: 99999
  }) {
    return request(data, 'dj.api.scrm.goods.listWithPageOutGoods')
  },
  /**商品编号获取商品信息（第三方）*/
  getEquityOutGoodsBySupplierProductId(data = {}) {
    return request(data, 'dj.api.scrm.goods.getEquityOutGoodsBySupplierProductId')
  },
  /** 同渠道商品编码校验*/
  sameGoodsCheck(data = {}) {
    return request(data, 'dj.api.scrm.goods.sameGoodsCheck')
  },
  /** 库存与下架校验*/
  stockAndStatusCheck(data = {}) {
    return request(data, 'dj.api.scrm.goods.stockAndStatusCheck')
  },
  /**商品新增*/
  createGoods(data = {}) {
    return request(data, 'dj.api.scrm.goods.insert')
  },
  /** 商品修改*/
  updateGoods(data = {}) {
    return request(data, 'dj.api.scrm.goods.update')
  },
  /**导出财务列表Excel*/
  exportBalanceList(data = {}) {
    return request(data, 'dj.api.get.equity.order.balance.list.export')
  },
  /** 获取渠道下所有品牌 */
  getAllBrandList(data = {}) {
    return request({
      ...data,
      supplier: 'HW',
      pageNum: 1,
      pageSize: 9999,
    }, 'dj.api.scrm.goods.getAllBrandList')
  },
}
export const carEquityManageApi = {
  /** 获取汽车权益列表*/
  getCarList(data = { pageSize: 9999, pageNum: 1 }) {
    return request(data, 'dj.api.scrm.car.list')
  },
  /**置顶权益*/
  setTop(data = {}) {
    return request(data, 'dj.api.scrm.car.setTop')
  },
  /** 修改汽车权益上架状态*/
  updateShelves(data = {}) {
    return request(data, 'dj.api.scrm.car.updateShelves')
  },
  /**新增汽车权益*/
  createEquity(data = {}) {
    return request(data, 'dj.api.scrm.car.insert')
  },
  /** 更新汽车权益*/
  updateEquity(data = {}) {
    return request(data, 'dj.api.scrm.car.update')
  },
}
export const goodsEquityManageApi = {
  /**获取商品权益列表*/
  getGoodsList(data) {
    return request({
      ...data,
      pageSize: 9999,
      pageNum: 1
    }, 'dj.api.scrm.goods.groupList')
  },
  /**获取商品权益分类列表*/
  getCategoryList(data = { pageSize: 9999, pageNum: 1 }) {
    return request(data, 'dj.api.scrm.goods.categoryList ')
  },
  /** 更新商品权益分类*/
  categoryUpdate(data = {}) {
    return request(data, 'dj.api.scrm.goods.categoryUpdate')
  },
  /** 根据id获取商品权益分类*/
  getCategorySelect(data = {}) {
    return request(data, 'dj.api.scrm.goods.categorySelect')
  },
  /** 删除商品权益分类*/
  categoryDelete(data = {}) {
    return request(data, 'dj.api.scrm.goods.categoryDelete')
  },
  /** 新增商品权益分类*/
  createCategory(data = {}) {
    return request(data, 'dj.api.scrm.goods.categoryInsert')
  },
  /**置顶权益*/
  setTop(data = {}) {
    return request(data, 'dj.api.scrm.goods.groupSetTop')
  },
  /**  修改商品权益上架状态*/
  updateShelves(data = {}) {
    return request(data, 'dj.api.scrm.goods.groupUpdateShelves')
  },
  /**新增商品权益*/
  createEquity(data = {}) {
    return request(data, 'dj.api.scrm.goods.groupInsert')
  },
  /**更新商品权益*/
  updateEquity(data = {}) {
    return request(data, 'dj.api.scrm.goods.groupUpdate')
  },
  /** 获取品牌列表*/
  getGoodsBrandList(data = {
    supplier: 'HW'
  }) {
    return request(data, 'dj.api.scrm.goods.brandList')
  },
  /* 获取品牌下商品形态列表*/
  getAppearanceList(data = {}) {
    return request({...data, supplier: 'HW' }, 'dj.api.scrm.goods.appearanceList')
  },

}
export const equityApi = {
  /*获取权益卡管理列表*/
  getEquityCardList(data = {}) {
    return request(data, 'dj.api.scrm.card.listWithPage')
  },
  /*新增权益卡*/
  newEquityCard(data = {}) {
    return request(data, 'dj.api.scrm.card.insert')
  },
  /*编辑权益卡*/
  editEquityCard(data = {}) {
    return request(data, 'dj.api.scrm.card.update')
  },
  /*权益卡批量生成*/
  generateMemberBatch(data = {}) {
    return request(data, 'dj.api.scrm.card.batchGenerate')
  },
  /*权益卡批次分页查询*/
  getEquityCardBatchList(data = {}) {
    return request(data, 'dj.api.scrm.card.listWithPageEquityBatch')
  },
  /*权益卡领用记录分页查询*/
  getEquityCardCollectionList(data = {}) {
    return request(data, 'dj.api.scrm.card.listWithPageEquityCard')
  },
  /*权益卡查询*/
  selectEquityCard(data = {}) {
    return request(data, 'dj.api.scrm.card.getById')
  },
  /*获取新建门店列表*/
  getMerchantList(data = {}) {
    return request(data, 'dj.api.scrm.goods.get.merchant.list')
  },
  /*导出*/
  cardExport(data = {}) {
    return request(data, 'dj.api.scrm.card.export')
  },
  /*获取领用门店列表*/
  getCollectionMerchantList(data = {}) {
    return request(data, 'dj.api.scrm.card.getByMerchantName')
  },
}